// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--lyqeX";
export var card = "styles-module--card--f7vAu";
export var title = "styles-module--title--qRXwv";
export var image = "styles-module--image--tQf0m";
export var text = "styles-module--text--XSCXy";
export var metadata = "styles-module--metadata--xMoJe";
export var subtitle = "styles-module--subtitle--AhJZO";
export var authors = "styles-module--authors--guEXv";